/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

:host {
  display: inline-block;
  font-size: var(--calcite-font-size--2);
  line-height: 1rem;
  font-weight: var(--calcite-font-weight-normal);
}

:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

:host([scale=s]) {
  --calcite-color-picker-spacing: 8px;
}
:host([scale=s]) .container {
  inline-size: 160px;
}
:host([scale=s]) .saved-colors {
  gap: 0.25rem;
  grid-template-columns: repeat(auto-fill, 20px);
}

:host([scale=m]) {
  --calcite-color-picker-spacing: 12px;
}
:host([scale=m]) .container {
  inline-size: 272px;
}

:host([scale=l]) {
  --calcite-color-picker-spacing: 16px;
  font-size: var(--calcite-font-size--1);
  line-height: 1rem;
}
:host([scale=l]) .container {
  inline-size: 464px;
}
:host([scale=l]) .section:first-of-type {
  padding-block-start: var(--calcite-color-picker-spacing);
}
:host([scale=l]) .saved-colors {
  grid-template-columns: repeat(auto-fill, 32px);
}
:host([scale=l]) .control-section {
  flex-wrap: nowrap;
  align-items: baseline;
  flex-wrap: wrap;
}
:host([scale=l]) .color-hex-options {
  display: flex;
  flex-shrink: 1;
  flex-direction: column;
  justify-content: space-around;
}
:host([scale=l]) .color-mode-container {
  flex-shrink: 3;
}

.container {
  background-color: var(--calcite-color-foreground-1);
  display: inline-block;
  border: 1px solid var(--calcite-color-border-1);
}

.control-and-scope {
  position: relative;
  display: flex;
  cursor: pointer;
  touch-action: none;
}

.color-field,
.control-and-scope {
  -webkit-user-select: none;
          user-select: none;
}

.scope {
  pointer-events: none;
  position: absolute;
  z-index: var(--calcite-z-index);
  block-size: 1px;
  inline-size: 1px;
  border-radius: 9999px;
  background-color: transparent;
  font-size: var(--calcite-font-size--1);
  outline-color: transparent;
}
.scope:focus {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
  outline-offset: 6px;
}

.hex-and-channels-group {
  inline-size: 100%;
}

.hex-and-channels-group,
.control-section {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.section {
  padding-block: 0 var(--calcite-color-picker-spacing);
  padding-inline: var(--calcite-color-picker-spacing);
}
.section:first-of-type {
  padding-block-start: var(--calcite-color-picker-spacing);
}

.sliders {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-inline-start: var(--calcite-color-picker-spacing);
  gap: var(--calcite-spacing-xxs);
}

.preview-and-sliders {
  display: flex;
  align-items: center;
  padding: var(--calcite-color-picker-spacing);
}

.color-hex-options,
.section--split {
  flex-grow: 1;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--calcite-color-text-1);
}

.color-mode-container {
  padding-block-start: var(--calcite-color-picker-spacing);
}

.channels {
  display: flex;
  row-gap: 0.125rem;
}

.channel[data-channel-index="3"] {
  inline-size: 159px;
}

:host([scale=s]) .channels {
  flex-wrap: wrap;
}
:host([scale=s]) .channel {
  flex-basis: 30%;
  flex-grow: 1;
}
:host([scale=s]) .channel[data-channel-index="3"] {
  inline-size: unset;
  margin-inline-start: unset;
}

:host([scale=l]) .channel[data-channel-index="3"] {
  inline-size: 131px;
}

.saved-colors {
  display: grid;
  gap: 0.5rem;
  padding-block-start: var(--calcite-color-picker-spacing);
  grid-template-columns: repeat(auto-fill, 24px);
}

.saved-colors-buttons {
  display: flex;
}

.saved-color {
  outline-offset: 0;
  outline-color: transparent;
  cursor: pointer;
}
.saved-color:focus {
  outline: 2px solid var(--calcite-color-brand);
  outline-offset: 2px;
}
.saved-color:hover {
  transition: outline-color var(--calcite-internal-animation-timing-fast) ease-in-out;
  outline: 2px solid var(--calcite-color-border-2);
  outline-offset: 2px;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}